import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex justify-between font-bold border-b-2 border-opacity-50 border-white mb-4 pb-2" }
const _hoisted_2 = { class: "flex justify-start" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "meta flex justify-end" }
const _hoisted_6 = {
  key: 0,
  class: "inmate text-xl md:text-3xl"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 320 512"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z" })
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 320 512"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M182.6 137.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H288c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z" })
], -1)
const _hoisted_9 = { class: "flex justify-between mb-4" }
const _hoisted_10 = { class: "flex justify-start" }
const _hoisted_11 = ["href", "aria-label"]
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "block md:flex" }
const _hoisted_14 = { class: "image w-full md:w-1/4" }
const _hoisted_15 = ["src", "alt"]
const _hoisted_16 = {
  key: 0,
  class: "mt-4 flex justify-start flex-wrap"
}
const _hoisted_17 = { class: "info w-full px-4 md:w-3/4" }
const _hoisted_18 = {
  key: 0,
  class: "text-left",
  style: {"white-space":"pre-line"}
}
const _hoisted_19 = { class: "grid grid-cols-2 md:grid-cols-5 text-left" }
const _hoisted_20 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_21 = {
  key: 0,
  class: "deceased-indicator"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "deceased-label" }, " Deceased", -1)
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = {
  key: 0,
  id: "cases",
  class: "mt-8"
}
const _hoisted_25 = { class: "grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 text-left" }
const _hoisted_26 = { class: "tagg" }
const _hoisted_27 = {
  key: 1,
  class: "border-b-2 border-white col-span-full mb-4 mt-4"
}
const _hoisted_28 = {
  key: 0,
  class: "flex justify-between mt-6"
}
const _hoisted_29 = {
  key: 0,
  class: "text-left"
}
const _hoisted_30 = {
  key: 1,
  class: "text-right"
}

import {caseCardFields, prisonerCardFields} from "@/@types/prisonerCardFields";
import {PrisonerRecord, Prisoner} from "@/@types/types";
import {ref} from 'vue';
import {prop} from "vue-class-component";

interface Props {
  record: PrisonerRecord
}

const heading4 = 'border-b border-white border-dashed border-opacity-50 my-3 pb-2 text-lg uppercase font-bold text-left'
const heading5 = 'font-bold mt-4 mb-2 uppercase'
const textValue = 'italic'



/**
 * Whether a field has anything worth printing a heading for.
 *
 * The check this replaces treated any non-empty array as a value, and the
 * data is full of arrays holding a single null: 3,767 case rows carry
 * ["Institution security" => [null]] against 4,974 that carry a genuinely
 * empty []. Both mean the same thing -- nothing recorded -- but only the
 * second was being caught, so thousands of cards printed an INSTITUTION
 * SECURITY heading with blank space under it.
 *
 * An array counts only if some element survives trimming; a scalar only if
 * it is not blank.
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'CardComponent',
  props: {
    record: {}
  },
  setup(__props: any) {

const props = __props
const showCases = ref<boolean>(false)


const hasValue = (value: any): boolean => {
  if (value === null || value === undefined) return false;

  if (Array.isArray(value)) {
    return value.some(item => item !== null && item !== undefined && String(item).trim() !== '');
  }

  return String(value).trim() !== '';
};

const parseValueForOutput = (value: any, fieldKey: string = ''): any => {

  if (typeof value === 'string' && value.includes('error')) {
    return null;
  }
  // If the value is an object and contains a key 'error', return null
  if (typeof value === 'object' && value.error) {
    return null;
  }

  if (typeof value === 'boolean') {
    return value ? 'Yes' : 'No';
  }

  if (Array.isArray(value)) {
    return value.join(', ');
  }

  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    // Parse the Y-M-D parts directly. Passing the bare date string to `new Date()`
    // treats it as UTC midnight, and reading it back with getDate()/toLocaleString()
    // uses the browser's local timezone — which shifts the date a day for viewers
    // behind UTC (e.g. Jan 1 displays as Dec 31). Splitting the string keeps the
    // calendar date exactly as stored, timezone-independent.
    const [year, monthNum, day] = value.split('-').map(Number);
    const suffix = (day >= 11 && day <= 13) ? 'th' : ['th','st','nd','rd'][day % 10] || 'th';
    // Construct with local-time parts (not a parsed string) so the month label isn't shifted.
    const month = new Date(year, monthNum - 1, day).toLocaleString('default', { month: 'short' });
    // On the prisoner card, hide the year for the Birthday field —
    // the full DOB still shows on the dedicated /prisoner page.
    if (fieldKey === 'Birthdate') {
      return `${month} ${day}${suffix}`;
    }
    return `${month} ${day}${suffix} ${year}`;
  }


  // If it's neither boolean nor array, return the value as is.
  return value;
};

const prisonerLinks: Array<{image: string, key: keyof Prisoner}> = [
  {image: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) Copyright 2023 Fonticons, Inc. --><path d="M352 256c0 22.2-1.2 43.6-3.3 64H163.3c-2.2-20.4-3.3-41.8-3.3-64s1.2-43.6 3.3-64H348.7c2.2 20.4 3.3 41.8 3.3 64zm28.8-64H503.9c5.3 20.5 8.1 41.9 8.1 64s-2.8 43.5-8.1 64H380.8c2.1-20.6 3.2-42 3.2-64s-1.1-43.4-3.2-64zm112.6-32H376.7c-10-63.9-29.8-117.4-55.3-151.6c78.3 20.7 142 77.5 171.9 151.6zm-149.1 0H167.7c6.1-36.4 15.5-68.6 27-94.7c10.5-23.6 22.2-40.7 33.5-51.5C239.4 3.2 248.7 0 256 0s16.6 3.2 27.8 13.8c11.3 10.8 23 27.9 33.5 51.5c11.6 26 20.9 58.2 27 94.7zm-209 0H18.6C48.6 85.9 112.2 29.1 190.6 8.4C165.1 42.6 145.3 96.1 135.3 160zM8.1 192H131.2c-2.1 20.6-3.2 42-3.2 64s1.1 43.4 3.2 64H8.1C2.8 299.5 0 278.1 0 256s2.8-43.5 8.1-64zM194.7 446.6c-11.6-26-20.9-58.2-27-94.6H344.3c-6.1 36.4-15.5 68.6-27 94.6c-10.5 23.6-22.2 40.7-33.5 51.5C272.6 508.8 263.3 512 256 512s-16.6-3.2-27.8-13.8c-11.3-10.8-23-27.9-33.5-51.5zM135.3 352c10 63.9 29.8 117.4 55.3 151.6C112.2 482.9 48.6 426.1 18.6 352H135.3zm358.1 0c-30 74.1-93.6 130.9-171.9 151.6c25.5-34.2 45.2-87.7 55.3-151.6H493.4z"/></svg>', key: 'Website'},
  {image: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) Copyright 2023 Fonticons, Inc. --><path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"/></svg>', key: 'Twitter'},
  {image: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) Copyright 2023 Fonticons, Inc. --><path d="M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z"/></svg>', key: 'Facebook'},
  {image: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) Copyright 2023 Fonticons, Inc. --><path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"/></svg>', key: 'Instagram'},
]


const mainCase = props.record.cases[0]

return (_ctx: any,_cache: any) => {
  return (_ctx.record.visible)
    ? (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["prisoner border-2 border-white mb-12 p-4 md:p-8", `has-maincase-${_unref(mainCase) ? 'yes' : 'no'}`]),
        key: _ctx.record.name
      }, [
        _createElementVNode("header", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h2", _hoisted_3, [
              _createElementVNode("a", {
                href: '/prisoner/' + (_ctx.record.slug || _ctx.record.id),
                class: "text-xl md:text-3xl",
                style: {"color":"#fff","text-decoration":"none","border-bottom":"1px solid rgba(255,255,255,0.2)"}
              }, _toDisplayString(_ctx.record.name ? (_ctx.record.AKA ? `${_ctx.record.AKA} (${_ctx.record.name})` : _ctx.record.name) : ''), 9, _hoisted_4)
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_ctx.record.inmateNumber)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, "#" + _toDisplayString(_ctx.record.inmateNumber), 1))
              : _createCommentVNode("", true),
            (_unref(mainCase) && !showCases.value)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 1,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (showCases.value = true)),
                  class: "ml-4 cursor-pointer text-sm mt-2"
                }, [
                  _createTextVNode("Show More "),
                  _hoisted_7
                ]))
              : _createCommentVNode("", true),
            (_unref(mainCase) && showCases.value)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 2,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (showCases.value = false)),
                  class: "ml-4 cursor-pointer text-sm mt-2"
                }, [
                  _createTextVNode("Hide "),
                  _hoisted_8
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("section", _hoisted_9, [
          _createElementVNode("section", _hoisted_10, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(prisonerLinks, (link) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: link.key
              }, [
                (_ctx.record[link.key])
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: _ctx.record[link.key],
                      target: "_blank",
                      rel: "noopener",
                      class: "text-lg",
                      "aria-label": link.key + ' link for ' + _ctx.record.name
                    }, [
                      _createElementVNode("span", {
                        class: "link-img",
                        innerHTML: link.image,
                        "aria-hidden": "true"
                      }, null, 8, _hoisted_12)
                    ], 8, _hoisted_11))
                  : _createCommentVNode("", true)
              ], 64))
            }), 64))
          ]),
          _createElementVNode("div", null, [
            (_unref(mainCase) && _unref(mainCase)['Incarceration Date'])
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: _normalizeClass(heading5)
                }, "Incarcerated: " + _toDisplayString(_unref(mainCase)["Incarceration Date"]), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("main", _hoisted_13, [
          _createElementVNode("section", _hoisted_14, [
            _createElementVNode("img", {
              class: "w-full h-auto",
              src: _ctx.record.Photo ? _ctx.record.Photo : '/images/no-image-available.svg',
              alt: _ctx.record.Photo ? 'Photo of ' + _ctx.record.name : 'No image available'
            }, null, 8, _hoisted_15),
            (_ctx.record.Ideologies && _ctx.record.Ideologies.length > 0)
              ? (_openBlock(), _createElementBlock("section", _hoisted_16, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.record.Ideologies, (ideology) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: ideology,
                      class: "tagg"
                    }, _toDisplayString(ideology), 1))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("section", _hoisted_17, [
            (_ctx.record.Description)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.record.Description), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_19, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(prisonerCardFields), (field) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: field.title
                }, [
                  (hasValue(_ctx.record[field.fieldKey]))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _createElementVNode("div", {
                          class: _normalizeClass(heading5)
                        }, _toDisplayString(field.title), 1),
                        _createElementVNode("div", {
                          class: _normalizeClass(textValue)
                        }, [
                          _createTextVNode(_toDisplayString(parseValueForOutput(_ctx.record[field.fieldKey], field.fieldKey) ?? ''), 1),
                          (field.title === 'Age' && _ctx.record['Death date'])
                            ? (_openBlock(), _createElementBlock("sup", _hoisted_21, [
                                _createTextVNode("†"),
                                _hoisted_22
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ])
          ])
        ]),
        (_ctx.record.calculatedPunishment)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "currentImprisonment",
              innerHTML: _ctx.record.calculatedPunishment
            }, null, 8, _hoisted_23))
          : _createCommentVNode("", true),
        _createVNode(_Transition, { name: "slide-fade" }, {
          default: _withCtx(() => [
            (showCases.value)
              ? (_openBlock(), _createElementBlock("section", _hoisted_24, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.record.cases, (criminalCase) => {
                    return (_openBlock(), _createElementBlock("div", null, [
                      _createElementVNode("div", _hoisted_25, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(caseCardFields), (field) => {
                          return (_openBlock(), _createElementBlock(_Fragment, null, [
                            (hasValue(criminalCase[field.fieldKey]))
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: field.title,
                                  class: "mb-4"
                                }, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(heading5)
                                  }, _toDisplayString(field.title), 1),
                                  (field.asTags)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: _normalizeClass(textValue)
                                      }, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(criminalCase[field.fieldKey], (i) => {
                                          return (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(i), 1))
                                        }), 256))
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", {
                                        key: 1,
                                        class: _normalizeClass(textValue)
                                      }, _toDisplayString(parseValueForOutput(criminalCase[field.fieldKey]) ?? '-'), 1))
                                ]))
                              : (field.separator)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_27))
                                : _createCommentVNode("", true)
                          ], 64))
                        }), 256))
                      ])
                    ]))
                  }), 256)),
                  (_unref(mainCase))
                    ? (_openBlock(), _createElementBlock("section", _hoisted_28, [
                        (_unref(mainCase)['Mailing address'])
                          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                              _createElementVNode("div", {
                                class: _normalizeClass(heading5)
                              }, "Mailing Address"),
                              _createElementVNode("div", {
                                class: _normalizeClass(textValue)
                              }, _toDisplayString(parseValueForOutput(_unref(mainCase)['Mailing address']) ?? '-'), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_unref(mainCase)['Physical address'])
                          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                              _createElementVNode("div", {
                                class: _normalizeClass(heading5)
                              }, "Physical Address"),
                              _createElementVNode("div", {
                                class: _normalizeClass(textValue)
                              }, _toDisplayString(parseValueForOutput(_unref(mainCase)['Physical address']) ?? '-'), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ], 2))
    : _createCommentVNode("", true)
}
}

})